{
  "FILTER": {
    "TITLE": "Filtrar conversas",
    "SUBTITLE": "Adicione os seus filtros abaixo e clique em 'Aplicar filtros' para eliminar a confusão no chat.",
    "EDIT_CUSTOM_FILTER": "Editar pasta",
    "CUSTOM_VIEWS_SUBTITLE": "Adicione ou remova filtros e atualize sua pasta.",
    "ADD_NEW_FILTER": "Adicionar filtro",
    "FILTER_DELETE_ERROR": "Não foi possível guardar! Por favor, adicione, pelo menos, um filtro para guardar.",
    "SUBMIT_BUTTON_LABEL": "Aplicar filtros",
    "UPDATE_BUTTON_LABEL": "Atualizar pasta",
    "CANCEL_BUTTON_LABEL": "Cancelar",
    "CLEAR_BUTTON_LABEL": "Limpar filtros",
    "FOLDER_LABEL": "Nome da pasta",
    "FOLDER_QUERY_LABEL": "Consulta de pasta",
    "EMPTY_VALUE_ERROR": "Valor obrigatório.",
    "TOOLTIP_LABEL": "Filtrar conversas",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "E",
      "OR": "OU"
    },
    "INPUT_PLACEHOLDER": "Inserir valor",
    "OPERATOR_LABELS": {
      "equal_to": "Igual a",
      "not_equal_to": "Não é igual a",
      "does_not_contain": "Não contém",
      "is_present": "Está presente",
      "is_not_present": "Não está presente",
      "is_greater_than": "É maior do que",
      "is_less_than": "É menor do que",
      "days_before": "É x dias antes",
      "starts_with": "Começa com",
      "equalTo": "Igual a",
      "notEqualTo": "Não é igual a",
      "contains": "Contém",
      "doesNotContain": "Não contém",
      "isPresent": "Está presente",
      "isNotPresent": "Não está presente",
      "isGreaterThan": "É maior do que",
      "isLessThan": "É menor do que",
      "daysBefore": "É x dias antes",
      "startsWith": "Começa com"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Verdadeiro",
      "FALSE": "Falso"
    },
    "ATTRIBUTES": {
      "STATUS": "Situação",
      "ASSIGNEE_NAME": "Nome do titular",
      "INBOX_NAME": "Nome da caixa de entrada",
      "TEAM_NAME": "Nome da equipa",
      "CONVERSATION_IDENTIFIER": "ID da conversa",
      "CAMPAIGN_NAME": "Nome da campanha",
      "LABELS": "Etiquetas",
      "BROWSER_LANGUAGE": "Idioma do browser",
      "PRIORITY": "Prioridade",
      "COUNTRY_NAME": "Nome do país",
      "REFERER_LINK": "Link de referência",
      "CUSTOM_ATTRIBUTE_LIST": "Lista",
      "CUSTOM_ATTRIBUTE_TEXT": "Texto",
      "CUSTOM_ATTRIBUTE_NUMBER": "Número",
      "CUSTOM_ATTRIBUTE_LINK": "Endereço",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Caixa de seleção",
      "CREATED_AT": "Criada em",
      "LAST_ACTIVITY": "Última atividade"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Valor obrigatório",
      "ATTRIBUTE_KEY_REQUIRED": "A chave do atributo é necessária",
      "FILTER_OPERATOR_REQUIRED": "Operador do filtro é necessário",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "O valor deve ser entre 1 e 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Filtros padrão",
      "ADDITIONAL_FILTERS": "Filtros adicionais",
      "CUSTOM_ATTRIBUTES": "Atributos personalizados"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Pretende guardar este filtro?",
        "LABEL": "Nome do filtro",
        "PLACEHOLDER": "Dê um nome ao filtro, para consultá-lo mais tarde.",
        "ERROR_MESSAGE": "Nome é obrigatório.",
        "SAVE_BUTTON": "Guardar filtro",
        "CANCEL_BUTTON": "Cancelar",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Pasta criada com sucesso.",
          "ERROR_MESSAGE": "Erro ao criar a pasta."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segmento criado com sucesso.",
          "ERROR_MESSAGE": "Erro ao criar segmento."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Editar pasta"
      },
      "DELETE": {
        "DELETE_BUTTON": "Apagar filtro",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Confirmar exclusão",
            "MESSAGE": "Tem a certeza que deseja excluir o filtro ",
            "YES": "Sim, excluir",
            "NO": "Não, manter"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Pasta criada com sucesso.",
          "ERROR_MESSAGE": "Erro ao apagar a pasta."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segmento apagado com sucesso.",
          "ERROR_MESSAGE": "Erro ao apagar segmento."
        }
      }
    }
  }
}
